var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"youtubeVid",attrs:{"width":_vm.getWidth,"height":"315","src":_vm.src}})}
var staticRenderFns = []

export { render, staticRenderFns }